import BaseService from '../../BaseService'
import type { CustomAxiosResponse, PageParams } from '../../types'
import type { InviteRewardConfig, InviteSummary, RechargeRebateConfig } from '../../types/invite'

class InviteService extends BaseService {
  /**
   * 获取邀请奖励配置
   * @param options 参数
   * @returns 邀请奖励配置列表
   */
  public async getInviteRewardConfigList(options?: PageParams): Promise<CustomAxiosResponse<InviteRewardConfig[]>> {
    return this.request.get<unknown, CustomAxiosResponse<InviteRewardConfig[]>>(
      `${this.apiUrl}/v1/user-center/app/invite/reward/config`,
      {
        params: options
      }
    )
  }

  /**
   * 获取充值返利配置
   * @param options 参数
   * @returns 充值返利配置列表
   */
  public async getRechargeRebateConfigList(options?: PageParams): Promise<CustomAxiosResponse<RechargeRebateConfig[]>> {
    return this.request.get<unknown, CustomAxiosResponse<RechargeRebateConfig[]>>(
      `${this.apiUrl}/v1/user-center/app/invite/recharge/rebate/config`,
      {
        params: options
      }
    )
  }

  /**
   * 获取邀请汇总信息
   * @returns 邀请汇总信息
   */
  public async getInviteSummary(): Promise<CustomAxiosResponse<InviteSummary>> {
    return this.request.get<unknown, CustomAxiosResponse<InviteSummary>>(
      `${this.apiUrl}/v1/user-center/app/user/invite/detail/summary`
    )
  }

  /**
   * 一键领取奖励
   * @returns void
   */
  public async claimAllReward(): Promise<CustomAxiosResponse<void>> {
    return this.request.post<unknown, CustomAxiosResponse<void>>(
      `${this.apiUrl}/v1/user-center/app/invite/reward/record/claim/all`
    )
  }
}

export default InviteService
